import React from 'react'
import {
  Segment,
  Item,
  Button,
  Icon
} from 'semantic-ui-react'
import {getStatus} from "../misc/Helpers";
import {Link} from "react-router-dom";
function TripList({ isTripsLoading, trips, handleBooking, user }) {

  const buttonStyle = (status, trip) => {
    return (status === 'PLANNED' && user.id !== trip.driver.id && trip.currentPassengers < trip.maxPassengers) ? {"display": "block"} : {"display": "none"}
  }

  let tripList
  if (trips.length === 0) {
    tripList = <><Item key='no-trips'>В настоящее время запланнированных поездок нет. Зайдите попозже</Item>
    <Item><Link to="/">На Главную</Link></Item></>
  } else {
      tripList = trips.map(trip => {
          return (
              <Item key={trip.id}>
                  <Item.Content>
                      <Item.Header>{trip.fromCity} - {trip.toCity}
                      </Item.Header>
                      <Item.Meta>{new Date(trip.tripTime).toLocaleString('ru',
                          { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false })}</Item.Meta>
                      <Item.Description>
                          Стоимость поездки {trip.cost} <br/>
                          Едет {trip.currentPassengers} из {trip.maxPassengers} возможных <br/>
                          Водитель {trip.driver.name} <Link to={'/reviews/' + trip.driver.id}>Смотреть отзывы</Link>
                      </Item.Description>
                      <Item.Extra>
                        Статус - {getStatus(trip.status)}
                      </Item.Extra>
                      <Item.Extra>
                          Примечание <br/>
                          {trip.notes}
                      </Item.Extra>
                      <Item.Extra style={buttonStyle(trip.status, trip)}>
                        <Button primary floated='right' onClick={() => handleBooking(trip.id)}>
                          Подать Заявку
                          <Icon name='right chevron' />
                        </Button>
                      </Item.Extra>
                  </Item.Content>
              </Item>
          )
      })
  }

  return (
    <Segment loading={isTripsLoading} color='blue'>
      <Item.Group divided unstackable relaxed>
        {tripList}
      </Item.Group>
    </Segment>
  )
}

export default TripList
